module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/fire-7b76f3b4ec4bb9eebc313bea7502f47f.svg";